<template>
    <div class="card">
        <div class="card-body">
            <h4 class="header-title mt-0">{{titles.organisationInfo}}</h4>
            <div v-if="disabledButton || countries == null">
                <Loading/>
            </div>
            <form :class="{'disabledInput': disabledButton}" @keyup.enter="onSubmit" class="text-left"
                  v-if="countries != null">
                <h3 class="text-center text-danger mb-3" v-if="errorMsg">{{ errorMsg }}</h3>
                <div class="px-4">
                    <div class="row">
                        <div class="col-lg-6">
                            <Input :icon="icons.organisations"
                                   :inputKey="'name'"
                                   :name="titles.organisationName"
                                   :validate="$v.formComponent.organisation.name"
                                   @method="getValue"/>
                        </div>
                        <div :class="{'disabledInput': this.idSelectedDomain != 'undefined' && $route.path.includes('organisation/add')
                                    ||$route.path.includes('organisation/update')|| (this.idSelectedDomain != null && $route.path.includes('validateUser'))
                        }" class="col-lg-6">
                            <DropDownVue :icon="icons.activityArea"
                                         :items="domains"
                                         :label="titles.activityArea"
                                         :validate="$v.formComponent.packCountryDomain.domain.id"
                                         @method="handleChangeDropDown"
                                         inputKey="domain"
                                         itemKey="id"
                                         itemValue="name"
                            />
                        </div>
                    </div>
                </div>
                <div class="px-4">
                    <div class="row">
                        <div class="col-lg-6">
                            <Input :icon="icons.address"
                                   :inputKey="'address'"
                                   :name="titles.organisationAddress"
                                   :validate="$v.formComponent.organisation.address"
                                   @method="getValue"/>
                        </div>
                        <div class="col-lg-6" :class="{'disabledInput': $v.formComponent.organisation.country.id.$model != null}">
                            <DropDownVue :icon="icons.country"
                                         :items="countries"
                                         :label="titles.country"
                                         :validate="$v.formComponent.organisation.country.id"
                                         @method="handleChangeDropDown"
                                         inputKey="country"
                                         itemKey="id"
                                         itemValue="name"
                            />
                        </div>

                    </div>
                </div>

                <div class="px-4">
                    <div class="row">
                        <div class="col-lg-6">
                            <Input :icon="icons.city"
                                   :inputKey="'city'"
                                   :name="titles.city"
                                   :validate="$v.formComponent.organisation.city"
                                   @method="getValue"/>
                        </div>
                        <div class="col-lg-6">
                            <Input :icon="icons.postalCode"
                                   :inputKey="'postalCode'"
                                   :name="titles.postalCode"
                                   :validate="$v.formComponent.organisation.postalCode"
                                   @method="getValue"
                            />
                        </div>
                    </div>
                </div>

                <div class="px-4">
                    <div class="row">
                        <div class="col-lg-6">
                            <Input :icon="icons.additionalAddress"
                                   :inputKey="'additionalAddress'"
                                   :name="titles.additionalAddress"
                                   :validate="$v.formComponent.organisation.additionalAddress"
                                   @method="getValue"/>
                        </div>
                        <div class="col-lg-6">
                            <DropDownVue :icon="icons.timezone"
                                         :items="Object.values(timezones)"
                                         :label="titles.timeZone"
                                         :validate="$v.formComponent.organisation.timezone"
                                         @method="handleChangeDropDown"
                                         inputKey="timezone"
                                         itemKey="value"
                                         itemValue="text"
                            />
                        </div>
                    </div>
                </div>

                <div class="px-4">
                    <div class="row">
                        <div class="col-lg-6">
                            <Input :icon="icons.taxRegistrationNumber"
                                   :inputKey="'taxRegistrationNumber'"
                                   :name="titles.taxRegistrationNumber"
                                   :validate="$v.formComponent.organisation.taxRegistrationNumber"
                                   @method="getValue"/>
                        </div>

                        <div class="col-lg-6">
                            <Input :icon="icons.WebSite"
                                   :inputKey="'website'"
                                   :name="titles.WebSite"
                                   :required="true"
                                   :validate="$v.formComponent.organisation.website"
                                   @method="getValue"/>
                        </div>
                    </div>
                </div>

                <div class="px-4">
                    <div class="row">
                        <div class="col-lg-6" v-if="formComponent.organisation.country.code !== 'TN'">
                            <Input :icon="icons.numSIRET"
                                   :inputKey="'numSiret'"
                                   :name="titles.numSIRET"
                                   :validate="$v.formComponent.organisation.numSiret"
                                   @method="getValue"/>
                        </div>
                        <div class="col-lg-6">
                            <VuePhoneNumberInput :border-radius="0"
                                                 :countries-height="20"
                                                 :ignored-countries="['IL']"
                                                 :required="$route.path.includes('validateUser')||($route.path.includes('organisation') && role == roles.client )? true: false"
                                                 :show-code-on-list="true"
                                                 :translations="translation"
                                                 :fetch-country=true
                                                 @input="phoneClicked"
                                                 color="#94878B"
                                                 id="phone"
                                                 ref="PhoneNumberInput"
                                                 size="sm"
                                                 v-model="formComponent.organisation.phone"
                            />
                            <br>
                            <div :class="{ 'invalid-feedback-erreur': $v.formComponent.organisation.phone
             && $v.formComponent.organisation.phone.required == false
              && $v.formComponent.organisation.phone.$dirty == true
               && $v.formComponent.organisation.phone.$error == true && phoneIsValid}"
                                 class="invalid-feedback">
                                {{titles.fieldIsRequired}}
                            </div>
                            <div :class="{ 'invalid-feedback-erreur': !phoneIsValid}"
                                 class="invalid-feedback">
                                {{titles.invalidPhoneNumber}}
                            </div>
                        </div>
                    </div>
                </div>
                <div class="px-4">
                    <div class="row">
                        <div class="col-md-12">

                            <button :disabled="isLoading"
                                    @click="previousTab"
                                    class="btn btn-standard-gradient px-5"
                                    style="float: left"
                                    type="button"
                                    v-if="($route.path.includes('organisation/add') && role != roles.client)
                        || $route.path.includes('client/add') && isEditable || (this.formName == 'validateUser')">
                                {{previous_btn}}
                            </button>
                            <button
                                    :disabled="isLoading"
                                    @click="onSubmit"
                                    class="btn btn-standard-gradient px-5"
                                    style="float: right"
                                    type="button"
                                    v-if="isEditable"
                            >
                                <b-spinner label="Spinning" small v-if="isLoading"></b-spinner>
                                {{name_btn}}
                            </button>
                            <modal-success :title="titles.updaterganisationMessage"
                                           @messageFromModal="closeModal"
                                           id="success-edit-organisation"/>
                        </div>
                    </div>
                </div>


            </form>
        </div>
    </div>
</template>

<script>
    import {getAllDomains} from '../services/domain.service';
    import {getUser} from '../../shared/services/user.service';
    import {getPackCountryDomain} from '../services/packCountryDomain.service';
    import {editOrganisation} from '../services/organisations.service';
    import {
        maxLength,
        minLength,
        numeric,
        required} from 'vuelidate/lib/validators';
    import {titles} from '../../../utils/general/titles';
    import {roles} from '../../../utils/general/roles';
    import Input from '@/components/common/Input.vue';
    import {domain} from '../models/domain';
    import {icons} from '../../../utils/general/icons';
    import timezones from '@/assets/data/timezones.json';
    import DropDownVue from '../../common/DropDownVue';
    import ModalSuccess from '../../common/modal-success';
    //import {name} from '../../../utils/general/routers';
    import {filterMixin} from '../../../utils/filterMixin';
    import {DEFAULT_COUNTRY_CODE} from '../../../config/config';
    import VuePhoneNumberInput from 'vue-phone-number-input';
    import {country} from '../models/country';
    import {getAllCountriesJson} from '../services/country.service';
    import Loading from '../../common/Loading';
    import requiredIf from "vuelidate/lib/validators/requiredIf";

    export default {
        name: 'OrganisationInfo',
        components: {Loading, ModalSuccess, Input, DropDownVue, VuePhoneNumberInput},
        props: {
            form: Object,
            role: String,
            codePromo: Boolean
        },
        data() {
            return {
                titles,
                roles,
                icons,
                timezones,
                translation: {
                    countrySelectorLabel: '',
                    countrySelectorError: '',
                    phoneNumberLabel: titles.phone,
                    example: titles.examplePhoneNumber
                },
                isLoading: false,
                errorMsg: '',
                countries: null,
                formComponent: this.form,
                voucher: this.codePromo,
                domains: [],
                validate: [],
                isEditable: true,
                name_btn:
                    this.$route.path.includes('add') || this.$route.path.includes('validateUser') ? titles.next : titles.update,
                previous_btn: titles.previous,
                formName: this.$route.path.includes('organisation') ? 'organisation' :
                    this.$route.path.includes('validateUser') ? 'validateUser' : 'client',
                packCountryDomain: null,
                filterList: [],
                phone: null,
                phoneIsValid: true,
                disabledButton: false,
                countryCode: '',
                idSelectedDomain: null,
            };
        },
        created() {
            this.idSelectedDomain = JSON.parse(localStorage.getItem("domain"));
                this.formComponent.organisation.country = this.formComponent.organisation.client.country != null?
                this.formComponent.organisation.client.country: this.formComponent.organisation.country
                    getAllCountriesJson().then(response => {
                this.countries = response.data.map(item => country(item));
                this.countries = this.countries.filter(item => item.code != DEFAULT_COUNTRY_CODE);
            });
            if (this.$route.path.includes('validateUser')) {
                if (this.formComponent.organisation.name == null) {
                    this.formComponent.packCountryDomain.domain = null;
                }
            }
            if ((localStorage.getItem("connected_domain")) != undefined &&
                (localStorage.getItem("connected_typePack")) != undefined &&
                this.$route.path.includes('organisation/add')) {
                this.idSelectedDomain =(localStorage.getItem("connected_domain")) ;
                this.idSelectedPack = (localStorage.getItem("connected_typePack")) ;

            }

            if (this.$route.path.includes('add')) {
                if(this.role == roles.client ){
                    getUser(this.$store.getters.user.id).then(response => {
                        this.formComponent.organisation.country = response.data.country;
                        this.countryCodeValue();
                    });
                }
                if (this.$cookies.get('user').idSelectedDomain != null) {
                    this.idSelectedDomain = this.$cookies.get('user').idSelectedDomain;
                }
                this.$cookies.remove('organisationItem');
                this.$cookies.remove('organisationDetailItem');
                this.$cookies.remove('packCountryDomainDetailItem');
                this.$cookies.remove('organisationItemIsEditable');
            }
            if (this.$cookies.isKey('subscriptionItem')
                && this.$cookies.isKey('organisationDetailItem') && this.$cookies.isKey('packCountryDomainDetailItem')) {
                this.formComponent = this.$cookies.get('subscriptionItem');
                this.formComponent.organisation = this.$cookies.get('organisationDetailItem');
                this.formComponent.packCountryDomain = this.$cookies.get('packCountryDomainDetailItem');
                this.isEditable = this.$cookies.get('organisationItemIsEditable');
                this.title = titles.organisationEditExpression;
                this.name_btn = titles.update;
            }
            this.getAllDomains();
            this.$emit('formValidate', this.$v);
            this.countryCodeValue();
        },
        updated() {
            this.formComponent.organisation.phoneNumberCode = this.$refs.PhoneNumberInput.countryCode;
        },
        mixins: [filterMixin],
        methods: {
            countryCodeValue() {
                this.countryCode = this.formComponent.organisation.phoneNumberCode;
                if (this.formComponent.organisation.country) {
                    this.countryCode = this.formComponent.organisation.country.code;
                }
            },
            phoneClicked() {
                if (this.$refs.PhoneNumberInput.isValid != true && this.formComponent.organisation.phone != null) {
                    this.phoneIsValid = false;
                } else {
                    this.phoneIsValid = true;
                }
                if (!this.$refs.PhoneNumberInput.hasEmptyPhone) {
                    this.$v.formComponent.organisation.phone.$touch();
                }
                this.$emit('phoneClick', this.phoneIsValid);
            },
            handleChangeDropDown(val, inputKey) {
                if (inputKey == 'domain') {
                    this.formComponent.packCountryDomain[inputKey] = val;
                    if (val != null) {
                        this.disabledButton = true;
                        this.$emit('disabledButton', this.disabledButton);
                        this.getPackCountryDomain();
                    }
                } else {
                    this.formComponent.organisation[inputKey] = val;
                    if(inputKey == 'country'){
                        if(val != null){
                            this.countryCodeValue();
                        }else{
                            this.formComponent.organisation.phoneNumberCode = 'FR';
                            this.countryCode= 'FR';
                        }
                    }

                }

            },
            getPackCountryDomain() {
                const actualCountry = this.formComponent.organisation.country.id ? this.formComponent.organisation.country.code :
                        DEFAULT_COUNTRY_CODE;
                getPackCountryDomain(this.formComponent.packCountryDomain.domain.name,
                    actualCountry, 'BackOffice', false)
                    .then(response => {
                        this.packCountryDomain = Object.values(response.data['hydra:member']);
                        this.packCountryDomain.country = this.formComponent.organisation.client.country;
                        this.disabledButton = false;
                        this.$emit('getPackCountryDomain', this.packCountryDomain, this.disabledButton);
                    });
            },
            getValue(inputKey, val) {
                this.formComponent.organisation[inputKey] = val;
                if (this.$v.formComponent.organisation[inputKey]) {
                    this.$v.formComponent.organisation[inputKey].$touch();
                }
            },
            previousTab() {
                this.$emit('nextTab', {
                    name: 'Client',
                    component: 'ClientInfo'
                }, this.voucher);
                if (this.formName == 'validateUser') {
                    this.$emit('previous', this.formComponent, 'step2');
                }
            },
            onSubmit() {
                this.$v.$touch();
                if (this.$v.$invalid || !this.phoneIsValid) {
                    return;
                }
                if (this.formName == 'validateUser') {
                    this.$emit('next', this.formComponent, 'step2');
                }
                if ((this.$route.path.includes('organisation/add') || this.$route.path.includes('client/add'))
                    && this.disabledButton == false) {
                    this.$emit('nextTab', {
                        name: 'Pack',
                        component: 'PackInfo'
                    }, this.voucher);
                } else if (this.$route.path.includes('organisation/update')) {
                    editOrganisation(
                        this.formComponent.organisation.id,
                        this.formComponent.organisation.name,
                        this.formComponent.organisation.address,
                        this.formComponent.organisation.country && this.formComponent.organisation.country.id != null ? this.formComponent.organisation.country : null,
                        this.formComponent.organisation.postalCode,
                        this.formComponent.organisation.city,
                        this.formComponent.organisation.additionalAddress,
                        this.formComponent.organisation.numSiret,
                        this.formComponent.organisation.phone,
                        this.formComponent.organisation.phoneNumberCode,
                        this.formComponent.organisation.taxRegistrationNumber,
                        this.formComponent.organisation.website,
                        this.formComponent.organisation.timezone ? this.formComponent.organisation.timezone.text : null
                    ).then(
                        response => {
                            this.$bvModal.show('success-edit-organisation');
                            this.isLoading = false;
                            return response;
                        },
                        error => {
                            const err = error.response;
                            this.errorMsg = err.data['hydra:description'];
                            this.isLoading = false;
                        }
                    );
                }
                this.errorMsg = null;
                this.isLoading = true;

            },
            closeModal() {
                if (this.$cookies.isKey('commercialItem')) {
                    this.$router.push({name: 'listCommercial'});
                } else if (this.$route.params.clientItem != null) {
                    this.$router.push({name: 'network'});
                } else {
                    this.$cookies.remove('organisationItem');
                    this.$cookies.remove('organisationDetailItem');
                    this.$cookies.remove('packCountryDomainDetailItem');
                    this.$cookies.remove('organisationItemIsEditable');
                    this.$router.push({name: 'organisation'});
                }
            },
            getAllDomains() {
                this.filterList = [];
                this.filterList = this.filterQueryGenerator(
                    this.filterList,
                    'isActive',
                    '1',
                    null
                );
                if (!this.$route.path.includes('organisation/update')) {
                    this.filterList = this.filterQueryGenerator(
                        this.filterList,
                        'enabled',
                        '1',
                        null
                    );
                }
                getAllDomains(
                    null, null, null, this.filterQuery
                ).then(response => {
                    this.domains = response.data['hydra:member'].map(actualDomain => domain(actualDomain));
                    if (this.idSelectedDomain != null ) {
                         const localDomain = this.domains.find(item => item.id == this.idSelectedDomain);
                         if (localDomain != null) {
                             this.formComponent.packCountryDomain.domain = localDomain;
                         }else {

                             this.formComponent.packCountryDomain.domain = this.idSelectedDomain;
                        }
                        this.getPackCountryDomain();

                    }
                });
            }
        },
        validations() {
            if ((this.formName == 'organisation'
                && this.$cookies.get('user').roles.find(item => item == 'ROLE_CLIENT') != undefined)
                || this.formName == 'validateUser') {
                return {
                    formComponent: {
                        organisation: {
                            name: {required},
                            address: {required},
                            country: {
                                required,
                                id: {required}
                            },
                            postalCode: {required},
                            city: {required},
                            additionalAddress: {},
                            numSiret: {required: requiredIf(function() {return this.formComponent.organisation.country.code !== "TN"}),
                                numeric, minLength: minLength(14), maxLength: maxLength(14)},
                            phone: {required},
                            phoneNumberCode: {required},
                            timezone: {required},
                            taxRegistrationNumber: {required},
                            website: {}
                        },
                        packCountryDomain: {
                            domain: {
                                required,
                                id: {required}
                            }
                        }
                    }
                };
            } else {
                return {
                    formComponent: {
                        organisation: {
                            name: {required},
                            address: {},
                            country: {
                                id: {}
                            },
                            postalCode: {},
                            city: {},
                            additionalAddress: {},
                            numSiret: {numeric, minLength: minLength(14), maxLength: maxLength(14)},
                            phone: {},
                            phoneNumberCode: {},
                            timezone: {},
                            taxRegistrationNumber: {},
                            website: {}
                        },
                        packCountryDomain: {
                            domain: {
                                required,
                                id: {required}
                            }
                        }
                    }
                };
            }
        }
    };
</script>

<style scoped>
    @import '../../../assets/style/css/vue-phone-number-input.css';
    @import '../../../assets/style/css/base.css';
</style>
